<div class="edit-actions">
    <button *ngIf="!loadingAction" matTooltip="Cancelar" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
      <mat-icon>clear</mat-icon>
 </button>
    <button *ngIf="!loadingAction" matTooltip="Previsualizar liquidación" (click)="viewReport()" mat-icon-button class="card-inline">
  <mat-icon>done</mat-icon>
</button>
    <mat-spinner [diameter]="20" *ngIf="loadingAction"></mat-spinner>
</div>

<mat-spinner *ngIf="loading"></mat-spinner>

<mat-tab-group *ngIf="!loading" (selectedIndexChange)="selectedIndexChange($event)">
    <mat-tab label="Datos generales">
        <div class="card-base margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <div class="card-content">
                        <app-medical-fee-payment-manual-amount #medicalFeePaymentAmount></app-medical-fee-payment-manual-amount>
                    </div>
                </div>
            </div>
        </div>
    </mat-tab>

    <mat-tab label="Detalle facturación">
        <div class="card-base margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <div class="card-content">
                        <app-medical-fee-payment-aliquot #medicalFeePaymentAliquot></app-medical-fee-payment-aliquot>
                    </div>
                </div>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>